import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=2b42e91e&scoped=true&lang=pug"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=2b42e91e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42e91e",
  null
  
)

export default component.exports